import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useModal from '../hooks/useModal';
import { classNames } from '../components/helpers/functions';
import {
	TemplateBoolean,
	TemplateField,
	TemplateReactSelect,
} from '../components/Attributes/Attributes_old';
import { FIELD_OPTIONS } from '../components/helpers/constants';
import Modal from '../components/Shell/Modal';
import Button from '../components/Button';
import useAsync from '../hooks/useAsync';
import {
	addModuleFields,
	deleteModuleField,
	updateModuleField,
} from '../api/modules';
import useRequired from '../hooks/useRequired';
import usePrevious from '../hooks/usePrevious';

export default () => {
	const navigate = useNavigate();
	const { open: modalData, setClose } = useModal('customField');
	const { moduleId, fieldId, field, onRefresh, ...model } = modalData || {};

	const [form, setForm] = useState({});
	const { setOpen: setDeleteModal, setClose: closeDeleteModal } =
		useModal('deleteModal');

	const prevModalData = usePrevious(modalData);
	useEffect(() => {
		if (!prevModalData && modalData) {
			setForm({
				id: fieldId,
				name: field?.label,
				type: FIELD_OPTIONS?.find((o) => o.value === field.type),
				required: field?.isRequired,
				searchable: field?.isSearchable,
			});
		}
	}, [modalData]);

	const { execute: onAddModuleField, status: addingField } = useAsync(
		addModuleFields,
		{
			immediate: false,
		}
	);
	const { execute: onEditModuleField, status: editingField } = useAsync(
		updateModuleField,
		{
			immediate: false,
		}
	);

	const { execute: onDeleteModuleField, status: deletingField } = useAsync(
		deleteModuleField,
		{
			immediate: false,
		}
	);

	const hasAllRequired = useRequired(form, ['name', 'type']);

	return (
		<Modal
			title={fieldId ? `Edit field` : 'Create new field'}
			name="customField"
		>
			<div className="grid gap-y-3">
				<TemplateField
					name="Label"
					onChange={(index, name) => setForm({ ...form, name })}
					value={form?.name}
				/>
				<TemplateReactSelect
					name="Type"
					options={FIELD_OPTIONS}
					onChange={(index, type) => setForm({ ...form, type })}
					value={form?.type}
					disabled={fieldId}
				/>
				{/*<TemplateBoolean
						span={1}
						name="Required"
						className="mr-3"
						onChange={(index, required) => setForm({ ...form, required })}
						value={form?.required}
					/>*/}
				<TemplateBoolean
					span={1}
					name="Searchable"
					onChange={(index, searchable) => setForm({ ...form, searchable })}
					value={form?.searchable}
				/>

				<div
					className={classNames(
						'col-span-2 flex mt-6',
						fieldId ? 'justify-between' : 'justify-end'
					)}
				>
					{fieldId && (
						<Button
							type="danger"
							onClick={() =>
								setDeleteModal({
									title: 'Are you sure you want to delete this field?',
									description:
										'Deleting this field will delete all data created using this field.  Please make sure this is what you want to do',
									confirmText: 'Absolutely Delete',
									onConfirm: () =>
										onDeleteModuleField(
											{
												id: moduleId,
												fieldId,
											},
											() => {
												closeDeleteModal();
												setClose();
												onRefresh({ id: moduleId }, null, { silent: true });
											}
										),
								})
							}
							className="sm:ml-0"
						>
							Delete
						</Button>
					)}
					<Button
						disabled={!hasAllRequired}
						onClick={() => {
							form?.id
								? onEditModuleField(
										{
											id: moduleId,
											fieldId,
											name: form?.name,
											type: form?.type?.value,
											searchable: form?.searchable,
											required: form?.required,
										},
										() => {
											onRefresh({ id: moduleId }, null, { silent: true });
											setClose();
										}
								  )
								: onAddModuleField(
										{
											id: moduleId,
											name: form?.name,
											type: form?.type?.value,
											searchable: form?.searchable,
											required: form?.required,
											active: true,
										},
										() => {
											onRefresh({ id: moduleId }, null, { silent: true });
											setClose();
										}
								  );
						}}
					>
						{fieldId
							? editingField === 'pending'
								? 'Saving...'
								: 'Save'
							: addingField === 'pending'
							? 'Creating...'
							: 'Create'}
					</Button>
				</div>
			</div>
		</Modal>
	);
};
